/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendNotificationToUserDto
 */
export interface SendNotificationToUserDto {
    /**
     * Identifier of the user receiving the notification
     * @type {string}
     * @memberof SendNotificationToUserDto
     */
    userId: string;
    /**
     * Type of notification to send
     * @type {string}
     * @memberof SendNotificationToUserDto
     */
    notificationType: SendNotificationToUserDtoNotificationTypeEnum;
    /**
     * Notification title
     * @type {string}
     * @memberof SendNotificationToUserDto
     */
    title: string;
    /**
     * Notification body
     * @type {string}
     * @memberof SendNotificationToUserDto
     */
    body: string;
    /**
     * Custom data payload (key-value pairs as strings)
     * @type {object}
     * @memberof SendNotificationToUserDto
     */
    data?: object;
    /**
     * Image URL for rich notifications
     * @type {string}
     * @memberof SendNotificationToUserDto
     */
    imageUrl?: string;
}


/**
 * @export
 */
export const SendNotificationToUserDtoNotificationTypeEnum = {
    AppointmentReminder: 'appointment_reminder',
    AppointmentScheduled: 'appointment_scheduled',
    AppointmentTimeChanged: 'appointment_time_changed',
    TreatmentUpdate: 'treatment_update',
    ChatMessage: 'chat_message',
    SystemAlert: 'system_alert',
    Marketing: 'marketing',
    Custom: 'custom',
    NewMessage: 'new_message',
    DataSharingRequest: 'data_sharing_request',
    InstructionReminder: 'instruction_reminder',
    AskCelleraChatExport: 'ask_cellera_chat_export',
    TreatmentPlanReady: 'treatment_plan_ready',
    InstructionReady: 'instruction_ready',
    ProcedureReady: 'procedure_ready',
    ReminderOccurrence: 'reminder_occurrence',
    BiomarkerOcrReady: 'biomarker_ocr_ready',
    MedicationOcrReady: 'medication_ocr_ready'
} as const;
export type SendNotificationToUserDtoNotificationTypeEnum = typeof SendNotificationToUserDtoNotificationTypeEnum[keyof typeof SendNotificationToUserDtoNotificationTypeEnum];


/**
 * Check if a given object implements the SendNotificationToUserDto interface.
 */
export function instanceOfSendNotificationToUserDto(value: object): value is SendNotificationToUserDto {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('notificationType' in value) || value['notificationType'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function SendNotificationToUserDtoFromJSON(json: any): SendNotificationToUserDto {
    return SendNotificationToUserDtoFromJSONTyped(json, false);
}

export function SendNotificationToUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendNotificationToUserDto {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'notificationType': json['notificationType'],
        'title': json['title'],
        'body': json['body'],
        'data': json['data'] == null ? undefined : json['data'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function SendNotificationToUserDtoToJSON(json: any): SendNotificationToUserDto {
    return SendNotificationToUserDtoToJSONTyped(json, false);
}

export function SendNotificationToUserDtoToJSONTyped(value?: SendNotificationToUserDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'notificationType': value['notificationType'],
        'title': value['title'],
        'body': value['body'],
        'data': value['data'],
        'imageUrl': value['imageUrl'],
    };
}

